module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/exchange-24aeb5a6f3632df9a071e7889163a10f.svg";